import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import FeedbackModal from "@/components/FeedbackModal";

export function PendingFeedbackStrip() {
  const [items, setItems] = useState([]);
  const [target, setTarget] = useState(null);
  const load = () => api.feedbackPending().then(d => setItems(d.items || [])).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  if (!items.length) return null;
  return (
    <div data-testid="pending-feedback-strip" className="mb-6 bg-amber-50 border border-amber-200 rounded-2xl p-5">
      <div className="text-xs uppercase tracking-[0.2em] text-amber-800 font-bold flex items-center gap-1.5">
        ⭐ Leave feedback ({items.length})
      </div>
      <p className="text-sm text-amber-900/80 mt-1">Recent events you can review — takes 20 seconds.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {items.slice(0, 6).map((it, idx) => (
          <button
            key={`${it.opportunity_id}-${it.to_user_id}-${idx}`}
            data-testid={`pending-feedback-item-${idx}`}
            onClick={() => setTarget(it)}
            className="text-xs px-3 py-1.5 rounded-full bg-white border border-amber-300 text-amber-900 hover:bg-amber-100"
          >
            {it.opportunity_title.slice(0, 32)} → {it.to_user_name}
          </button>
        ))}
      </div>
      <FeedbackModal
        open={!!target}
        item={target}
        onClose={() => setTarget(null)}
        onSubmitted={() => { setTarget(null); load(); }}
      />
    </div>
  );
}
